let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9BbYL")).then(() => parcelRequire('1rEKn'));